import React from 'react';
import Image from '../assets/papi.png'

import {FaGithub ,  FaArrowDown,  FaLinkedin, FaInstagram, FaLaptop} from 'react-icons/fa';

import {TypeAnimation} from 'react-type-animation'

import {motion} from 'framer-motion'
import {fadeIn} from '../variants'
const Banner = () => {


  return(
    <section className='min-h-[85vh] lg:min-h-[78vh] flex items-center' id='home'>
      <div className='container mx-auto'>
         <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12' >
      <div className='flex-1 text-center font-secondary lg:text-left'>
        <motion.h1
        variants={fadeIn('up' ,0.4)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.7}}
        className='text-[50px] font-bold leading-[0.8] lg:text-[110px]' >VISHESH<span> {""}TIWARI</span></motion.h1>
        <motion.div
        variants={fadeIn('up' ,0.4)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.7}}
        className='mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]'>
        <span className=' text-white mr-4'> I m a geek at  </span>
        <TypeAnimation sequence={[
          'Web-DEV',2000,
          'CYBER SECURITY',2000,
          'DEVOPS',2000,
          'Cloud ',2000,
        ]} 
        speed={50}
        className='text-accent'
        wrapper='span'
        repeat={Infinity}
        ></TypeAnimation>
        </motion.div>
        <motion.p
        variants={fadeIn('up' ,0.5)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.7}}
        className='mb-8 max-w-lg mx-auto lg:mx-0'>
          I am a student, a self taught programmer and a technical enthusiast, and an open source contributor a hobbist problem solver. would love to work together and collaborate 

        </motion.p>
        <motion.div 
        variants={fadeIn('up' ,0.8)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.7}}
        className='flex max-w-max gap-x-6 items-center mb-12'>
        <button className='btn btn-lg'> <FaArrowDown /></button> 
        <a href='mailto:tvishesh593@gmail.com' className='text-gradient btn-link'>
        Contact Me
          </a>         
        </motion.div>
        <motion.div 
        variants={fadeIn('up' ,0.8)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.7}}
        className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'>
          <a href="https://www.instagram.com/vishesh_tiwaari/">
            <FaInstagram></FaInstagram>
          </a>
          <a href="https://github.com/vishesh-hue/">
            <FaGithub></FaGithub>
          </a>
          <a href="https://www.linkedin.com/in/vishesh-tiwari-a2007b1b9/">
            <FaLinkedin></FaLinkedin>
          </a>
          <a href="https://leetcode.com/vishesh_tiwari/">
            <FaLaptop></FaLaptop> 
          </a>
        </motion.div>
       
      </div>

      <motion.div
      variants={fadeIn('down' ,0.4)}
      initial='hidden'
      whileInView={'show'}
      viewport={{once:false , amount: 0.7}}
      className='hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px]'>
      <img src = {Image}></img>

      </motion.div>
     

      </div>
      </div>
   
    </section>
  )
 

};

export default Banner;
